import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import deCommon from './locales/de/common.json';
import deNav from './locales/de/nav.json';
import deAuth from './locales/de/auth.json';
import deDashboard from './locales/de/dashboard.json';
import deDogs from './locales/de/dogs.json';
import deAccount from './locales/de/account.json';
import deBreeding from './locales/de/breeding.json';
import deBreedingStation from './locales/de/breedingStation.json';
import deAdmin from './locales/de/admin.json';
import deNotes from './locales/de/notes.json';
import deProspects from './locales/de/prospects.json';
import deLanding from './locales/de/landing.json';
import dePricing from './locales/de/pricing.json';
import deHealth from './locales/de/health.json';
import dePregnancy from './locales/de/pregnancy.json';
import dePedigree from './locales/de/pedigree.json';
import dePlanning from './locales/de/planning.json';
import deSupport from './locales/de/support.json';
import deContracts from './locales/de/contracts.json';
import deShows from './locales/de/shows.json';
import deTransfer from './locales/de/transfer.json';
import deDna from './locales/de/dna.json';

import enCommon from './locales/en/common.json';
import enNav from './locales/en/nav.json';
import enAuth from './locales/en/auth.json';
import enDashboard from './locales/en/dashboard.json';
import enDogs from './locales/en/dogs.json';
import enAccount from './locales/en/account.json';
import enBreeding from './locales/en/breeding.json';
import enBreedingStation from './locales/en/breedingStation.json';
import enAdmin from './locales/en/admin.json';
import enNotes from './locales/en/notes.json';
import enProspects from './locales/en/prospects.json';
import enLanding from './locales/en/landing.json';
import enPricing from './locales/en/pricing.json';
import enHealth from './locales/en/health.json';
import enPregnancy from './locales/en/pregnancy.json';
import enPedigree from './locales/en/pedigree.json';
import enPlanning from './locales/en/planning.json';
import enSupport from './locales/en/support.json';
import enContracts from './locales/en/contracts.json';
import enShows from './locales/en/shows.json';
import enTransfer from './locales/en/transfer.json';
import enDna from './locales/en/dna.json';

import frCommon from './locales/fr/common.json';
import frNav from './locales/fr/nav.json';
import frAuth from './locales/fr/auth.json';
import frDashboard from './locales/fr/dashboard.json';
import frDogs from './locales/fr/dogs.json';
import frAccount from './locales/fr/account.json';
import frBreeding from './locales/fr/breeding.json';
import frBreedingStation from './locales/fr/breedingStation.json';
import frAdmin from './locales/fr/admin.json';
import frNotes from './locales/fr/notes.json';
import frProspects from './locales/fr/prospects.json';
import frLanding from './locales/fr/landing.json';
import frPricing from './locales/fr/pricing.json';
import frHealth from './locales/fr/health.json';
import frPregnancy from './locales/fr/pregnancy.json';
import frPedigree from './locales/fr/pedigree.json';
import frPlanning from './locales/fr/planning.json';
import frSupport from './locales/fr/support.json';
import frContracts from './locales/fr/contracts.json';
import frShows from './locales/fr/shows.json';
import frTransfer from './locales/fr/transfer.json';
import frDna from './locales/fr/dna.json';

import itCommon from './locales/it/common.json';
import itNav from './locales/it/nav.json';
import itAuth from './locales/it/auth.json';
import itDashboard from './locales/it/dashboard.json';
import itDogs from './locales/it/dogs.json';
import itAccount from './locales/it/account.json';
import itBreeding from './locales/it/breeding.json';
import itBreedingStation from './locales/it/breedingStation.json';
import itAdmin from './locales/it/admin.json';
import itNotes from './locales/it/notes.json';
import itProspects from './locales/it/prospects.json';
import itLanding from './locales/it/landing.json';
import itPricing from './locales/it/pricing.json';
import itHealth from './locales/it/health.json';
import itPregnancy from './locales/it/pregnancy.json';
import itPedigree from './locales/it/pedigree.json';
import itPlanning from './locales/it/planning.json';
import itSupport from './locales/it/support.json';
import itContracts from './locales/it/contracts.json';
import itShows from './locales/it/shows.json';
import itTransfer from './locales/it/transfer.json';
import itDna from './locales/it/dna.json';

import nlCommon from './locales/nl/common.json';
import nlNav from './locales/nl/nav.json';
import nlAuth from './locales/nl/auth.json';
import nlDashboard from './locales/nl/dashboard.json';
import nlDogs from './locales/nl/dogs.json';
import nlAccount from './locales/nl/account.json';
import nlBreeding from './locales/nl/breeding.json';
import nlBreedingStation from './locales/nl/breedingStation.json';
import nlAdmin from './locales/nl/admin.json';
import nlNotes from './locales/nl/notes.json';
import nlProspects from './locales/nl/prospects.json';
import nlLanding from './locales/nl/landing.json';
import nlPricing from './locales/nl/pricing.json';
import nlHealth from './locales/nl/health.json';
import nlPregnancy from './locales/nl/pregnancy.json';
import nlPedigree from './locales/nl/pedigree.json';
import nlPlanning from './locales/nl/planning.json';
import nlSupport from './locales/nl/support.json';
import nlContracts from './locales/nl/contracts.json';
import nlShows from './locales/nl/shows.json';
import nlTransfer from './locales/nl/transfer.json';
import nlDna from './locales/nl/dna.json';

export const SUPPORTED_LANGUAGES = ['de', 'en', 'fr', 'it', 'nl'] as const;
export type SupportedLanguage = (typeof SUPPORTED_LANGUAGES)[number];

export const STORAGE_KEY = 'canebase_lang';

const resources = {
  de: {
    common: deCommon, nav: deNav, auth: deAuth, dashboard: deDashboard, dogs: deDogs,
    account: deAccount, breeding: deBreeding, breedingStation: deBreedingStation,
    admin: deAdmin, notes: deNotes, prospects: deProspects, landing: deLanding, pricing: dePricing, health: deHealth, pregnancy: dePregnancy, pedigree: dePedigree, planning: dePlanning, support: deSupport, contracts: deContracts, shows: deShows, transfer: deTransfer, dna: deDna
  },
  en: {
    common: enCommon, nav: enNav, auth: enAuth, dashboard: enDashboard, dogs: enDogs,
    account: enAccount, breeding: enBreeding, breedingStation: enBreedingStation,
    admin: enAdmin, notes: enNotes, prospects: enProspects, landing: enLanding, pricing: enPricing, health: enHealth, pregnancy: enPregnancy, pedigree: enPedigree, planning: enPlanning, support: enSupport, contracts: enContracts, shows: enShows, transfer: enTransfer, dna: enDna
  },
  fr: {
    common: frCommon, nav: frNav, auth: frAuth, dashboard: frDashboard, dogs: frDogs,
    account: frAccount, breeding: frBreeding, breedingStation: frBreedingStation,
    admin: frAdmin, notes: frNotes, prospects: frProspects, landing: frLanding, pricing: frPricing, health: frHealth, pregnancy: frPregnancy, pedigree: frPedigree, planning: frPlanning, support: frSupport, contracts: frContracts, shows: frShows, transfer: frTransfer, dna: frDna
  },
  it: {
    common: itCommon, nav: itNav, auth: itAuth, dashboard: itDashboard, dogs: itDogs,
    account: itAccount, breeding: itBreeding, breedingStation: itBreedingStation,
    admin: itAdmin, notes: itNotes, prospects: itProspects, landing: itLanding, pricing: itPricing, health: itHealth, pregnancy: itPregnancy, pedigree: itPedigree, planning: itPlanning, support: itSupport, contracts: itContracts, shows: itShows, transfer: itTransfer, dna: itDna
  },
  nl: {
    common: nlCommon, nav: nlNav, auth: nlAuth, dashboard: nlDashboard, dogs: nlDogs,
    account: nlAccount, breeding: nlBreeding, breedingStation: nlBreedingStation,
    admin: nlAdmin, notes: nlNotes, prospects: nlProspects, landing: nlLanding, pricing: nlPricing, health: nlHealth, pregnancy: nlPregnancy, pedigree: nlPedigree, planning: nlPlanning, support: nlSupport, contracts: nlContracts, shows: nlShows, transfer: nlTransfer, dna: nlDna
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'de',
    supportedLngs: SUPPORTED_LANGUAGES as unknown as string[],
    defaultNS: 'common',
    ns: Object.keys(resources.de),
    interpolation: { escapeValue: false },
    detection: {
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: STORAGE_KEY,
      caches: ['localStorage']
    }
  });

export default i18n;
